export const ANALYTICS_CONFIG_ELEMENT_ID = 'config-analytics';
